import { Box, CircularProgress, CssBaseline, Fade, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import getCDNImagePath from '../../Utils/getCDNImagePath';

interface FallbackProps {
    business?: boolean;
}

export default function Fallback({ business }: Readonly<FallbackProps>) {
    const [showLoadingInfo, setShowLoadingInfo] = useState(false);

    useEffect(() => {
        const timerId = setTimeout(() => {
            setShowLoadingInfo(true);
        }, 3000);

        return () => clearTimeout(timerId);
    }, []);

    return (
        <Box
            sx={{
                alignItems: 'center',
                backgroundColor: business ? '#1c4e71' : '#4EC1ED30',
                display: 'flex',
                flexDirection: 'column',
                height: '100dvh',
                justifyContent: 'center',
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            <CssBaseline />
            <img
                alt="Renki Logo"
                height={window.innerWidth > 600 ? 400 : 250}
                src={
                    business
                        ? getCDNImagePath('renki/renkilogo_text_stacked_business.png')
                        : getCDNImagePath('renki/renkilogo_text_stacked.png')
                }
            />

            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    px: 5,
                    textAlign: 'center',
                }}
            >
                {showLoadingInfo ? (
                    <Fade in timeout={3500}>
                        <Typography component="div" sx={{ color: business ? '#b3e1fd' : '#1C4E71' }} variant="h5">
                            Loading page content, please wait.
                        </Typography>
                    </Fade>
                ) : null}
                <Fade in timeout={3500}>
                    <CircularProgress size={40} sx={{ color: business ? '#b3e1fd' : '#1C4E71', mt: 5 }} />
                </Fade>
            </Box>
        </Box>
    );
}
